/* RESPONSIBLE TEAM: team-inbox-management */
// @ts-ignore
import DefaultAvatars from '@intercom/pulse/lib/default-avatars';

// eslint-disable-next-line @intercom/intercom/use-asset-url
const DEFAULT_AVATAR_PATH = '/assets/default-avatars';

// Our default avatar URLs have dark and light mode options. If dark mode is
// enabled and it's a default URL, return the dark mode variation, otherwise
// return the original URL.
export function transformAvatarUrl(url: string, dark = false) {
  try {
    if (dark) {
      let inputUrl = new URL(url);

      if (inputUrl.pathname.includes(DEFAULT_AVATAR_PATH)) {
        let finReferenceUrl = new URL(DefaultAvatars.fin[128]);

        // asset pipeline hash is different between light and dark mode for fin avatar
        if (inputUrl.pathname === finReferenceUrl.pathname) {
          let darkModeAvatarUrl = new URL(DefaultAvatars.fin['128-dark']);
          // update the pathname while keeping the CDN host the same
          // EU region uses a different CDN host(static.intercomassets.eu) than the US region(static.intercomassets.com)
          // and it's better to use the relevant one
          inputUrl.pathname = darkModeAvatarUrl.pathname;

          return inputUrl.toString();
        } else {
          return url.replace(/\.png$/, '-dark.png');
        }
      }
    }

    return url;
  } catch (error) {
    return url;
  }
}
